"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSectionBody = exports.StyledSectionSeparator = exports.StyledSection = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSection = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #fff;\n  border-radius: 4px;\n"], ["\n  background-color: #fff;\n  border-radius: 4px;\n"])));
exports.StyledSectionSeparator = styled_components_1.default.hr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid #d7dbdb;\n  margin: 0;\n"], ["\n  border: 1px solid #d7dbdb;\n  margin: 0;\n"])));
exports.StyledSectionBody = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 32px;\n"], ["\n  padding: 32px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
